import { axiosInstance } from "@/axios/config";

const BASE = "employee/admin/funding-form-submissions";

export default {
  list(params = {}) {
    return axiosInstance.get(BASE, { params });
  },

  convert(ids) {
    return axiosInstance.post(`${BASE}/convert`, { ids });
  },
  //============== Reject url ==============
  reject(ids) {
    return axiosInstance.post(`${BASE}/reject`, { ids });
  },
  //============== End Reject url ==============
};
